import { Link } from "react-router";
import ImageWithBasePath from "../image-with-base-path";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/core/redux/store";
import { setMobileSidebar } from "@/core/redux/sidebarSlice";
import HeaderNav from "../header/headerNav";
import { all_routes } from "@/routes/all_routes";

const CommonHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
  const menuOpened = useSelector((state: RootState) => {
    const s = state.sidebar as any;
    // try known/possible property names, fallback to false
    return (s.menuOpened ?? s.mobileSidebar ?? s.isOpen ?? false) as boolean;
  });

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (menuOpened) document.body.classList.add("menu-opned");
    else document.body.classList.remove("menu-opned");
  }, [menuOpened]);

  const onMobileBtn = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(!menuOpened));
  };

  const onMenuClose = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(false));
  };
  // ...existing code...
  return (
    <>
      {/* Header */}
      <header className={`header header-default ${isScrolled ? "fixed" : ""}`}>
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={onMobileBtn}>
                <i className="fa-solid fa-bars" />
              </Link>
              <Link to={all_routes.home} className="navbar-brand logo">
                <ImageWithBasePath
                  src="assets/img/logo.svg"
                  className="img-fluid"
                  alt="Logo"
                />
              </Link>
            </div>
            <div className="header-menu">
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <Link to={all_routes.home} className="menu-logo">
                    <ImageWithBasePath
                      src="assets/img/logo.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </Link>
                  <Link
                    id="menu_close"
                    className="menu-close"
                    to="#"
                    onClick={onMenuClose}
                  >
                    <i className="fas fa-times" />
                  </Link>
                </div>
                <HeaderNav />
                <div className="header-items">
                  {/* Item 1 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Contact Information</h3>
                    <div className="support-item mb-3">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-messages-3" />
                      </div>
                      <div>
                        <p className="title">General Inquiries</p>
                        <h5 className="link">info@example.com</h5>
                      </div>
                    </div>
                    <div className="support-item">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-call-calling" />
                      </div>
                      <div>
                        <p className="title">Emergency Cases</p>
                        <h5 className="link">+1 24565 89856</h5>
                      </div>
                    </div>
                  </div>
                  {/* Item 2 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Follow Us</h3>
                    <ul className="d-flex align-items-center gap-2 social-iyem">
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-facebook" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-x-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="header-items-button">
                    <Link
                      to={all_routes.login}
                      className="btn btn-primary btn-primary-gradient"
                    >
                      <i className="isax isax-lock-1 me-2" />
                      Sign In
                    </Link>
                    <Link to={all_routes.register} className="btn btn-dark">
                      <i className="isax isax-user-tick4 me-2" />
                      Sign Up
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <ul className="nav header-navbar-rht">
              <li>
                <Link
                  to={all_routes.login}
                  className="btn btn-md btn-primary-gradient"
                >
                  <i className="isax isax-lock-1 me-2" />
                  <span>Sign Up</span>
                </Link>
              </li>
              <li>
                <Link to={all_routes.register} className="btn btn-md btn-dark">
                  <i className="isax isax-user-tick me-2" />
                  <span>Register</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="details-btn"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#support_item"
                >
                  <i className="isax isax-menu5" />
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      {/* /Header */}
    </>
  );
};

export default CommonHeader;
